<template>
  <v-container id="Auditoria" fluid>
    <v-row>
      <v-col col="12" class="text-center mb-8">
        <h2 class="font-heading text-h3 mb-4">
          Laboral
        </h2>
        <v-divider class="mx-auto bg-brand-orange" style="max-width: 100px; height: 4px;"></v-divider>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" md="6">
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Nuestro servicio laboral comprende todos los aspectos vinculados a la relación laboral, abarcando
          la totalidad de los deberes y obligaciones que tiene el empleador con sus empleados y los distintos
          organismos de recaudación.
        </p>
        <v-expansion-panels variant="accordion">
          <v-expansion-panel
            v-for="(panel, i) in panels"
            :key="i"
            :text="panel.text"
            :title="panel.title"
          ></v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" md="6">
        <v-img
          src="https://www.sydle.com/blog/assets/post/auditoria-interna-649c70daaabaad5335fb1bb6/audit-icon.jpg"
          alt="Auditoria"
          class="rounded-lg"
          cover
          height="400"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      panels: [
        {
          title: 'Liquidación de Sueldos y sus cargas sociales',
          text: 'Contamos con un moderno sistema de liquidación de sueldos, el cual nos permite acceder en forma \
          inmediata a toda la información laboral y confeccionar los recibos de sueldos y sus cargas sociales. Este \
          servicio comprende la liquidación de sueldos en su totalidad, con altas, bajas, recibos de sueldos, registro \
          único, formularios para pago de aportes y contribuciones de seguridad social y obra social, sindicatos, etc.'
        },
        {
          title: 'Administración de Legajos y notificaciones',
          text: "Dada la importancia de los costos laborales dentro de las empresas, es necesario contar con un \
          eficiente sistema de Legajos y Notificaciones, no solo para cumplir con normas legales, sino también para \
          apercibir y sancionar correctamente a los empleados que no cumplan correctamente con sus funciones, lo cual \
          servirá en un futuro para no tener que abonar indemnizaciones por despido sin causa."
        },
        {
          title: 'Atención de inspecciones y verificaciones',
          text: "Los distintos organismos de fiscalización laboral, desde hace unos años han lanzado una campaña \
          de “blanquiamiento laboral”. Esto es llevado a cabo por medio de inspecciones en las empresas, donde se \
          confeccionan actas del personal relevado. Nuestro servicio consiste en atender a los inspectores e instruir \
          a los empleados en sus declaraciones, ya que estas quedan asentadas en actas y pueden constituir una prueba en contra."
        },
        {
          title: 'Asesoramiento laboral',
          text: "En el contexto inflacionario que vive el país genera cambios en los costos laborales de difícil \
          predicción, y en muchos casos con subas superiores a las de la inflación “real”. Nuestro servicio comprende \
          el asesoramiento e información permanente a nuestros clientes de estos incrementos, analizando las mejores \
          alternativas de contratación para menguar estas subas en sus costos."
        },
        {
          title: 'Otros Servicios Laborales',
          text: "Dentro de nuestros servicios laborales se encuentra: preparación de archivos informaticos para el \
          pago de sueldos via bancos, certificaciones de servicios, tramitación de libretas especiales \
          (IERIC, RENATRE, etc.), información de novedades, carga de vínculos familiares de los empleados, \
          tramitación de altas y bajas, régimen laboral de servicio domestico."
        }
      ]
    }
  }
}
</script>
<style lang="">
    
</style>